import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const RichTextEditor = ({
  name,
  onChange,
  onBlur,
  value,
  height = "100px",
  width = "100%",
}) => {
  return (
    <div>
      <ReactQuill
        theme='snow'
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        id={name}
        style={{ height, width }}
      />
    </div>
  );
};

export default RichTextEditor;
